<script>
import ACPLayout from "@/Layouts/ACP";
import { Link } from "@inertiajs/inertia-vue3";

export default {
    layout: ACPLayout,
    components: { Link },

    props: {
        event: Object,
        userEmail: String,
    },

    methods: {
        toggleActive() {
            axios.patch(route("acp.events.activate", { event: this.event.id })).then((res) => {
                this.event.active = res.data.active;
            });
        },
    },
};
</script>

<template>
    <div class="container mt-4">
        <div class="mb-3">
            <Link :href="route('acp.events')" class="btn btn-secondary btn-sm">
                <i class="fas fa-arrow-left"></i> {{ $trans("acp.back") }}
            </Link>
        </div>

        <div class="card bg-dark text-light border-secondary mb-4">
            <div class="card-header d-flex justify-content-between align-items-center">
                <h5 class="mb-0">{{ event.name || "–" }}</h5>
                <div class="d-flex gap-2">
                    <span class="badge" :class="event.active ? 'bg-success' : 'bg-secondary'">
                        {{ event.active ? $trans("event.active_yes") : $trans("event.active_no") }}
                    </span>
                    <button class="btn btn-sm" :class="event.active ? 'btn-warning' : 'btn-success'" @click="toggleActive">
                        {{ event.active ? $trans("acp.event_deactivate") : $trans("acp.event_activate") }}
                    </button>
                </div>
            </div>
            <div class="card-body">
                <dl class="row mb-0">
                    <dt class="col-sm-3">{{ $trans("company.id") }}</dt>
                    <dd class="col-sm-9">{{ event.id }}</dd>

                    <dt class="col-sm-3">{{ $trans("event.event_type") }}</dt>
                    <dd class="col-sm-9">{{ event.type ? $trans("event.type_" + event.type.name) : "–" }}</dd>

                    <dt class="col-sm-3">{{ $trans("event.organizer") }}</dt>
                    <dd class="col-sm-9">{{ event.organizer_name }}</dd>

                    <dt class="col-sm-3">{{ $trans("acp.event_created_by") }}</dt>
                    <dd class="col-sm-9">{{ userEmail || "–" }}</dd>

                    <dt class="col-sm-3">{{ $trans("event.starting_at") }}</dt>
                    <dd class="col-sm-9">{{ event.starting_at }}</dd>

                    <dt class="col-sm-3">{{ $trans("event.ending_at") }}</dt>
                    <dd class="col-sm-9">{{ event.ending_at }}</dd>

                    <dt class="col-sm-3">{{ $trans("event.description") }}</dt>
                    <dd class="col-sm-9" style="white-space: pre-wrap">{{ event.description || "–" }}</dd>

                    <template v-if="event.data">
                        <dt class="col-sm-3">{{ $trans("acp.event_data") }}</dt>
                        <dd class="col-sm-9">
                            <pre class="text-light mb-0" style="font-size: 0.85em">{{ JSON.stringify(event.data, null, 2) }}</pre>
                        </dd>
                    </template>

                    <dt class="col-sm-3">{{ $trans("acp.created_at") }}</dt>
                    <dd class="col-sm-9">{{ event.created_at }}</dd>
                </dl>
            </div>
        </div>
    </div>
</template>
